import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedReorder202602: FaireAdPerformancePeriodEntity =
  {
    token: "perf_p4_under_utilized_reorder_202602",
    type: "adPerformancePeriod",
    scope: "REORDER_MARKETPLACE",
    periodType: "RECEIPT",
    startDate: "2026-02-01",
    endDate: "2026-02-28",
    impressions: 5148,
    clicks: 67,
    adsSpendDollars: 256,
    budgetDollars: 500,
    salesDollars: 5184,
    bestEstimateRoas: 20.25,
    bestEstimateType: "ACTUALIZED",
    budgetUtilization: 0.51,
    reorderConversions: 7,
    dataAvailableAtDate: "2026-03-04",
    meta: {
      source: "mock",
      importedAt: "2026-07-06T00:00:00.000Z",
      importedBy: "advertiser-profiles",
    },
  };
